import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import { filterNullOrUndefined } from '../common';
import { ThemeStore } from './UedStore';
var store;
function registerThemeComponents(id, component) {
  getStore().registerThemeComponents(id, component);
}
function registerTheme(theme) {
  getStore().registerTheme(theme);
}

// 用于项目里便捷地初始化数据
function initTheme(options) {
  var themes = options.themes,
    templates = options.templates,
    scope = options.scope,
    _options$enabledTheme = options.enabledThemes,
    enabledThemes = _options$enabledTheme === void 0 ? [] : _options$enabledTheme,
    defaultTheme = options.defaultTheme,
    modifyVars = options.modifyVars;
  var ued = getStore();
  var themeComponents = ued.state.themeComponents;
  templates.forEach(function (_ref) {
    var id = _ref.id,
      component = _ref.component;
    return themeComponents.set(id, component);
  });
  var iocThemes = ued.state.themes;
  themes.forEach(function (theme) {
    return iocThemes.set(theme.name, theme);
  });
  var finalState = {
    scope: scope,
    modifyVars: modifyVars,
    defaultTheme: defaultTheme,
    themeComponents: themeComponents,
    themes: iocThemes,
    enabledThemes: (enabledThemes === null || enabledThemes === void 0 ? void 0 : enabledThemes.length) ? enabledThemes : _toConsumableArray(ued.state.themes.keys())
  };
  ued.updateState(filterNullOrUndefined(finalState));
}
function getThemeKeys() {
  return _toConsumableArray(getStore().state.themes.keys());
}
function getStore() {
  if (typeof window !== 'undefined') {
    if (!window.__themeStore) {
      window.__themeStore = new ThemeStore();
    }
    return window.__themeStore;
  } else {
    if (!store) {
      store = new ThemeStore();
    }
    return store;
  }
} // 添加一个受主题控制的自定义样式

function addThemeStyle() {
  var _getStore;
  (_getStore = getStore()).addCustomStyles.apply(_getStore, arguments);
}
export { registerTheme, registerThemeComponents, initTheme, addThemeStyle, getThemeKeys, getStore };